module.exports = "b0365d6a625f681abaca9af676c78135.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/beam.png
// module id = 81
// module chunks = 0